// extracted by mini-css-extract-plugin
export default {"container":"pnA5C7","small":"o5phxM","medium":"y8AcBr","big":"waO3AM","extraBig":"lQsvCA","label":"o8aezM","price":"f19vsn"};